import $ from "jquery";
import cryptojs from "crypto-js";
import s from "./cate";
import rt from "./rt";
import axios from 'axios'
import { Modal, Toast } from 'bootstrap'

var sx = {};

sx.enable = function (obj, enabled) {
  if (enabled) {
    obj.removeClass("disabled");
    obj.removeAttr("disabled");
  } else {
    obj.addClass("disabled");
    obj.attr("disabled", "disabled");
  }
}

sx.substring = function (str, n, suffix) {
  if (sx.isNothingOrEmpty(str)) {
    return ""
  }
  if (str.length > n) {
    return str.substring(0, n) + suffix
  } else {
    return str;
  }
}

sx.text2html = function (str) {
  if (sx.isNothingOrEmpty(str)) {
    return ""
  }
  return str.replaceAll("\n", "<br>")
}

sx.permmerge = function (perm, perms) {
  if (perm.auth_view === "1") {
    perms[1] = "1";
  }
  if (perm.auth_list === "1") {
    perms[2] = "1";
  }
  if (perm.auth_add === "1") {
    perms[3] = "1";
  }
  if (perm.auth_edit === "1") {
    perms[4] = "1";
  }
  if (perm.auth_del === "1") {
    perms[5] = "1";
  }
  if (perm.auth_details === "1") {
    perms[6] = "1";
  }
  if (perm.auth_preview === "1") {
    perms[7] = "1";
  }
  if (perm.auth_import === "1") {
    perms[8] = "1";
  }
  if (perm.auth_export === "1") {
    perms[9] = "1";
  }
  if (perm.auth_setup === "1") {
    perms[10] = "1";
  }
  return perms
}

sx.permArray2Dict = function (array) {
  var perm = {
    auth_view: false,
    auth_list: false,
    auth_add: false,
    auth_edit: false,
    auth_del: false,
    auth_details: false,
    auth_preview: false,
    auth_import: false,
    auth_export: false,
    auth_setup: false
  }
  if (array[1] === "1") perm.auth_view = true;
  if (array[2] === "1") perm.auth_list = true;
  if (array[3] === "1") perm.auth_add = true;
  if (array[4] === "1") perm.auth_edit = true;
  if (array[5] === "1") perm.auth_del = true;
  if (array[6] === "1") perm.auth_details = true;
  if (array[7] === "1") perm.auth_preview = true;
  if (array[8] === "1") perm.auth_import = true;
  if (array[9] === "1") perm.auth_export = true;
  if (array[10] === "1") perm.auth_setup = true;
  return perm;
}

sx.grant = function (roleidlist, permlist) {
  var perms = {};
  $.each(roleidlist, function (index, roleid) {
    console.log(index)
    $.each(permlist, function (idx, perm) {
      if (perm.roleid == roleid) {
        if (perms[perm.path]) {
          perms[perm.path] = sx.permmerge(perm, perms[perm.path]);
        } else {
          perms[perm.path] = sx.permmerge(perm, [perm.path, "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"]);
        }
      }
    });
  });
  return perms;
}

sx.getoptname = function (id, list) {
  if (sx.isNothingOrEmpty(id)) {
    return '';
  }
  const index = list.findIndex(function (item) {
    return item.val == id
  })
  if (index > -1) {
    return list[index].txt.trim();
  } else {
    return '';
  }
}

sx.tagsName2Code = function (tag, taglist) {
  if (sx.isNothingOrEmpty(tag)) {
    return "";
  }
  var tagnamelist = tag.split(",")
  var tagcodelist = []
  $.each(tagnamelist, function (index, tagname) {
    const idx = taglist.findIndex(function (item) {
      return item.txt == tagname
    })
    if (idx > -1) {
      tagcodelist.push(taglist[idx].val)
    }
  });
  return tagcodelist.join(",")
}

sx.split = function (str, separator) {
  if (sx.isNothingOrEmpty(str)) {
    return [];
  }
  return str.split(separator)
}

sx.tagsCode2Name = function (tag, taglist) {
  if (sx.isNothingOrEmpty(tag) || sx.isNothingOrEmpty(taglist)) {
    return "";
  }
  var tagcodelist = tag.split(",")
  var tagnamelist = []
  $.each(tagcodelist, function (index, tagcode) {
    const idx = taglist.findIndex(function (item) {
      return item.val == tagcode
    })
    if (idx > -1) {
      tagnamelist.push(taglist[idx].txt)
    }
  });
  return tagnamelist.join(",")
}

sx.getord = function (lvidx, lv, ordidx, ord, items) {
  var ordbase;
  var maxord;
  switch (lv) {
    case -1:
      maxord = 10;
      $.each(items, function (index, item) {
        if (item[lvidx] == 0) {
          var current = parseInt(item[ordidx] / 100000000)
          if (current >= maxord) {
            maxord = current
          }
        }
      });
      maxord = parseInt(maxord + 1) * 100000000
      break;
    case 0:
      ordbase = parseInt(ord / 100000000);
      maxord = ordbase * 100;
      $.each(items, function (index, item) {
        if (item[lvidx] == 1) {
          var current = parseInt(item[ordidx] / 100000000);
          if (current == ordbase) {
            var ordtemp = parseInt(item[ordidx] / 1000000);
            if (ordtemp >= maxord) {
              maxord = ordtemp
            }
          }
        }
      });
      maxord = parseInt(maxord + 1) * 1000000;
      break;
    case 1:
      ordbase = parseInt(ord / 1000000);
      maxord = ordbase * 100;
      $.each(items, function (index, item) {
        if (item[lvidx] == 2) {
          var current = parseInt(item[ordidx] / 1000000);
          if (current == ordbase) {
            var ordtemp = parseInt(item[ordidx] / 10000);
            if (ordtemp >= maxord) {
              maxord = ordtemp
            }
          }
        }
      });
      maxord = parseInt(maxord + 1) * 10000;
      break;
    case 2:
      ordbase = parseInt(ord / 10000);
      maxord = ordbase * 100;
      $.each(items, function (index, item) {
        if (item[lvidx] == 3) {
          var current = parseInt(item[ordidx] / 10000);
          if (current == ordbase) {
            var ordtemp = parseInt(item[ordidx] / 100);
            if (ordtemp >= maxord) {
              maxord = ordtemp
            }
          }
        }
      });
      maxord = parseInt(maxord + 1) * 100;
      break;
    case 3:
      ordbase = parseInt(ord / 100);
      maxord = ordbase * 100;
      $.each(items, function (index, item) {
        if (item[lvidx] == 4) {
          var current = parseInt(item[ordidx] / 100);
          if (current == ordbase) {
            var ordtemp = item[ordidx];
            if (ordtemp >= maxord) {
              maxord = ordtemp
            }
          }
        }
      });
      maxord = parseInt(maxord + 1);
      break;
    default:
      maxord = "";
  }
  return maxord
};

sx.gethtmltags = function (tag) {
  if (sx.isNothingOrEmpty(tag)) {
    return "";
  }
  var tags = tag.split(",")
  var html = ""
  $.each(tags, function (index, item) {
    html += "<span class='custom-tag'>" + item + "</span>"
  });
  return html
};

sx.gethtmltags2 = function (tag, prefix, suffix) {
  if (sx.isNothingOrEmpty(tag)) {
    return "";
  }
  var tags = tag.split(",")
  var html = ""
  $.each(tags, function (index, item) {
    html += prefix + item + suffix
  });
  return html
};

sx.gettags = function (arraylist) {
  var tags = []
  $.each(arraylist, function (index, item) {
    tags.push({ text: item.txt })
  });
  return tags
};

sx.leftpadhtml = function (n, val) {
  var html = "<span>";
  for (var i = 0; i < n; i++) {
    html += "&nbsp;&nbsp;&nbsp;&nbsp;";
  }
  html += val;
  html += "</span>";
  return html;
}

sx.leftpadhtml2 = function (n, val) {
  var html = "";
  for (var i = 0; i < n; i++) {
    html += "　";
  }
  html += val;
  return html;
}

sx.getYesOrNo = function (val) {
  if (val === "1") {
    return "<i class='fa fa-circle-o' aria-hidden='true'></i>"
  } else {
    return "<i class='fa fa-times' aria-hidden='true'></i>"
  }
}

sx.getcateHtml = function (val, kbn, locale) {
  if (sx.isNothingOrEmpty(val)) {
    return ""
  }
  var cate = s[kbn];
  var v = cate[val];
  return "<span class='" + v.class + "'>" + v[locale] + "</span>"
};

sx.getDictList = function (arraylist, val) {
  var dictlist = []
  $.each(arraylist, function (index, item) {
    if (item.val == val) {
      dictlist.push(item)
    }
  });
  return dictlist;
};

sx.getOptOfDictList = function (arraylist, val) {
  var dict = {}
  $.each(arraylist, function (index, item) {
    dict[item.val] = item
  });
  var cate = dict[val];
  if (cate) {
    return cate.txt
  } else {
    return ""
  }
};

sx.getopt = function (arraylist, val) {
  var dict = {}
  $.each(arraylist, function (index, item) {
    dict[item.val] = item
  });

  var cate = dict[val];
  if (cate) {
    return "<span class='custom-tag'>" + cate.txt + "</span>"
  } else {
    return ""
  }
};

sx.getcate = function (val, kbn, locale) {
  if (sx.isNothingOrEmpty(val)) {
    return ""
  }
  var cate = s[kbn];
  var v = cate[val];
  return v[locale]
};

sx.opts = function (kbn, locale) {
  var list = [];
  var cate = s[kbn];
  for (var val in cate) {
    var v = cate[val];
    list.push({
      txt: v[locale],
      val: val
    });
  }
  return list
};

sx.encrypt = function (word, keyStr) {
  if (sx.isNothingOrEmpty(keyStr)) {
    keyStr = 'ABGHNJHGSHUYG12';
  }
  var encrypted = cryptojs.AES.encrypt(word, keyStr);
  return encrypted.toString();
};

sx.decrypt = function (word, keyStr) {
  if (sx.isNothingOrEmpty(word)) {
    return word;
  }
  if (sx.isNothingOrEmpty(keyStr)) {
    keyStr = 'ABGHNJHGSHUYG12';
  }
  var decrypt = cryptojs.AES.decrypt(word, keyStr);
  return decrypt.toString(cryptojs.enc.Utf8);
};

sx.isNothingOrEmpty = function (obj) {
  if (obj == null || obj == undefined || obj === '' || obj === 'null' || obj == {}) {
    return true
  } else {
    return false
  }
}

sx.ifNothingOrEmpty = function (obj, str) {
  if (sx.isNothingOrEmpty(obj)) {
    return str
  } else {
    return obj
  }
}

sx.toastWarning = function (msg) {
  sx.toast(msg, "warning");
};
sx.toastInfo = function (msg) {
  sx.toast(msg, "info");
};
sx.toastError = function (msg) {
  sx.toast(msg, "danger");
};
sx.toastSuccess = function (msg) {
  sx.toast(msg, "success");
};

sx.toast = function (msg, level) {
  var option = {
    delay: 4000
  };
  const mytoast = new Toast(document.querySelector(".toast"), option);
  $(".toast-body").html(msg);
  $(".toast-body").addClass("alert-" + level);
  mytoast.show();
};

sx.showWaiting = function () {
  const mymodal = new Modal(document.querySelector("#my-waiting"));
  mymodal.show();
  return mymodal;
};

sx.hideWaiting = function (mymodal) {
  setTimeout(function () {
    if (mymodal) {
      mymodal.hide();
    }
  }, 400);
};

sx.upload = function (files, callback, callbackerr) {
  if (files && files.length == 0) {
    const res = {
      status: "ok",
      message: "none",
      data: {
        pathlist: []
      }
    }
    callback(res);
  } else {
    var formData = new FormData();
    var i = 0;
    $.each(files, function (index, file) {
      if (file.raw) {
        formData.append("uploaded_file[" + i + "]", file.raw);
        i = i + 1;
      }
    });
    formData.append("token", localStorage.getItem('token'));
    formData.append("bucketid", '13');
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        token: localStorage.getItem('token')
      }
    };
    var baseurl = localStorage.getItem('baseurl') || 'https://cloud.salesmini.cn'
    axios.post(baseurl + '/app/cmshelper/upload', formData, config).then(function (res) {
      console.log(res.data);
      if (res.data && res.data.status === 'ok') {
        callback(res.data);
      } else {
        callbackerr(res.data);
      }
    })
  }
};

sx.request = function (requrl, params, callback, callbackerr) {
  params.tzoffset = localStorage.getItem('tzoffset')
  $.post(
    requrl,
    params,
    function (data, textStatus, jqXHR) {
      if (data.status === 'outdated') {
        callbackerr(data);
      } else {
        callback(data);
      }
      console.log(textStatus)
      console.log(jqXHR)
      localStorage.setItem("serverError", false)
    },
    "json"
  ).fail(function (jqXHR, textStatus, errorThrown) {
    localStorage.setItem("serverError", true)
    console.log(errorThrown);
  });
};

sx.format = function (str, dict) {
  var result = str;
  for (var key in dict) {
    var tmp = result;
    var val = dict[key];
    result = tmp.replaceAll("{" + key + "}", val);
  }
  return result
}

sx.formatrt = function (str) {
  if (!str) {
    return str
  }
  var result = str;
  // 単語
  result = sx.formattango(result)

  // 音読漢字
  var grouplist = result.match(new RegExp("[^>]([\u4E00-\u9FFF]{2,})", 'g'))
  console.log(grouplist);
  $.each(grouplist, function (idx, item) {
    console.log(idx)
    var tmp = result;
    result = tmp.replaceAll(item, sx.formatkanji(item));
  })

  // 訓読
  for (var key in rt.hiragana) {
    var tmp = result;
    var val = rt.hiragana[key];
    result = tmp.replace(new RegExp('([^>])' + key + '([ぁ-おき-なぬら-わん])', 'g'), "$1<ruby>" + key + "$2<rt>" + val + "$2</rt></ruby>");
  }
  return result;
};

sx.formatkanji = function (str) {
  var result = str;
  for (var key in rt.kanji) {
    var tmp = result;
    var val = rt.kanji[key];
    result = tmp.replace(new RegExp(key, 'g'), "<ruby>" + key + "<rt>" + val + "</rt></ruby>");
  }
  return result;
}

sx.formattango = function (str) {
  var result = str;
  for (var key in rt.tango) {
    var tmp = result;
    var val = rt.tango[key];
    result = tmp.replace(new RegExp(key, 'g'), "<ruby>" + key + "<rt>" + val + "</rt></ruby>");
  }
  return result;
}

sx.formatem = function (str, list) {
  if (!str) {
    return str
  }
  var result = str;
  $.each(list, function (idx, val) {
    console.log(idx)
    var tmp = result;
    result = tmp.replaceAll(val, "<em>" + val + "</em>");

    var val2 = val.replace(val, rt.hiragana[val]);
    tmp = result;
    result = tmp.replaceAll(val2, "<em>" + val2 + "</em>");
  })
  return result
}

sx.login = function (requrl, params, callback) {
  var username = localStorage.getItem('username')
  var password = localStorage.getItem('password')
  if (!sx.isNothingOrEmpty(password)) {
    password = sx.decrypt(password, '')
  }
  var para = {
    username: username,
    password: password,
    token: ''
  }
  var baseurl = localStorage.getItem('baseurl') || 'https://cloud.salesmini.cn'
  sx.request(
    baseurl + localStorage.getItem('loginurl'),
    para,
    function (result) {
      if (result.status === 'ok') {
        localStorage.setItem('token', result.data.token)
        params.token = localStorage.getItem('token')
        params.tzoffset = localStorage.getItem('tzoffset')
        sx.request(
          requrl,
          params,
          function (data) {
            if (data.status === 'ok') {
              callback(data);
            } else {
              console.log('The username and / or password is incorrect')
            }
          },
          function (result) {
            console.log(result)
          }
        )
      } else {
        console.log('The username and / or password is incorrect')
      }
    },
    function (result) {
      console.log(result)
    }
  )
}

export default sx;
